/* eslint-disable camelcase */

export type TIssueState = 'all' | 'pending' | 'in_progress' | 'awaiting_response' | 'resolved' | ''

/**
 * Issue statuses by snakecase keys and titlecase value
 */
export const ISSUE_STATUS_LABEL: Record<TIssueState, string> = {
  pending: 'Pending',
  in_progress: 'In Progress',
  awaiting_response: 'Awaiting Response',
  resolved: 'Resolved',
  all: 'All',
  '': '',
}

/**
 * Issue statuses constants
 */
export enum IssueStatus {
  pending = 'pending',
  in_progress = 'in_progress',
  awaiting_response = 'awaiting_response',
  resolved = 'resolved',
}
